import {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
    Label,
} from "@headlessui/react";
import Icon from "@web-ui/components/Icon";
import Tooltip from "@web-ui/components/Tooltip";
import { SelectOption } from "@web-ui/types/select";

type SelectProps = {
    className?: string;
    classButton?: string;
    label?: string;
    /** The spoken name when no visible label is shown (a compact select in a toolbar whose options name themselves). */
    ariaLabel?: string;
    tooltip?: string;
    value: SelectOption | null;
    onChange: (value: SelectOption) => void;
    options: SelectOption[];
    isBlack?: boolean;
    placeholder?: string;
};

const Select = ({
    className,
    classButton,
    label,
    ariaLabel,
    tooltip,
    value = null,
    onChange,
    options,
    isBlack,
    placeholder,
}: SelectProps) => {
    return (
        <Listbox
            className={`${className || ""}`}
            value={value}
            onChange={onChange}
            as="div"
        >
            {label && (
                <Label className="flex items-center mb-1">
                    <div className="textfield__label">{label}</div>
                    {tooltip && (
                        <Tooltip className="ms-1.5" content={tooltip} />
                    )}
                </Label>
            )}
            <ListboxButton
                aria-label={label ? undefined : ariaLabel}
                className={`input input--secondary group flex justify-between items-center text-start fill-t-secondary data-[focus]:shadow-[0_0_0_2px_var(--control-focus)] data-[open]:shadow-[0_0_0_2px_var(--control-focus)] ${
                    isBlack
                        ? "bg-linear-to-b border-transparent from-shade-04 to-shade-03 !text-t-light !fill-t-light dark:from-shade-10 dark:to-shade-08"
                        : ""
                } ${classButton || ""}`}
            >
                {value?.name ? (
                    <div className="truncate">{value.name}</div>
                ) : (
                    <div className="truncate text-t-secondary/50">
                        {placeholder}
                    </div>
                )}
                <Icon
                    className="shrink-0 ms-2 fill-inherit transition-transform group-[[data-open]]:rotate-180"
                    name="chevron"
                />
            </ListboxButton>
            {/* Tixora's select list (HeroUI list box in a select popover): styles/controls.css .menu, exactly as wide as
                its field (owner 2026-10-11), never the menu's own minimum. */}
            <ListboxOptions
                className="menu !w-[var(--button-width)] !min-w-[var(--button-width)]"
                anchor="bottom start"
                transition
            >
                {options.map((option) => (
                    <ListboxOption
                        className="menu__item menu__item--selectable"
                        key={option.id}
                        value={option}
                    >
                        <span className="truncate">{option.name}</span>
                        <Icon className="menu__check" name="check" />
                    </ListboxOption>
                ))}
            </ListboxOptions>
        </Listbox>
    );
};

export default Select;
